import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../../../_helpers/Api'

//images
import docIcon from '../../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../../assets/img/icons/close.png'
import loader from '../../../../../../assets/img/loader.svg'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { trans } from '../../../../../../_providers/Translation'
import { FormControlLabel } from '@mui/material'
import BlueSwitch from '@/components/partials/BlueSwitch'

function Payments(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        loading: false,
        onSave: null
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        show: data => {
            setPopup(prev => ({
                ...prev,
                loading: false,
                data: data
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'partners/settings/edit'

        let data = new FormData(e.target)

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof popup.onSave === 'function') {
                    popup.onSave()
                }

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    function handleSwitchChange(e) {
        const { name, checked } = e.target

        setPopup((prev) => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: checked ? 1 : 0,
            },
        }))
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary medium`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.paymentsSettings')}
                        </h2>
                        <p>
                            {trans('subheadings.paymentsSettings')}
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        {trans('labels.bankData')}
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_bank_active"
                                                checked={popup.data?.is_bank_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_bank_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        {trans('labels.bank')}
                                    </label>

                                    <input
                                        type="text"
                                        name="bank_name"
                                        value={popup.data ? popup.data.bank_name : ''}
                                        className={validations && validations.bank_name ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_bank_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        IBAN
                                    </label>

                                    <input
                                        type="text"
                                        name="bank_iban"
                                        value={popup.data ? popup.data.bank_iban : ''}
                                        className={validations && validations.bank_iban ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_bank_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        SWIFT
                                    </label>

                                    <input
                                        type="text"
                                        name="bank_swift"
                                        value={popup.data ? popup.data.bank_swift : ''}
                                        className={validations && validations.bank_swift ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_bank_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        Sort Code
                                    </label>

                                    <input
                                        type="text"
                                        name="bank_sort_code"
                                        value={popup.data ? popup.data.bank_sort_code : ''}
                                        className={validations && validations.bank_sort_code ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_bank_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        Account number
                                    </label>

                                    <input
                                        type="text"
                                        name="bank_account_number"
                                        value={popup.data ? popup.data.bank_account_number : ''}
                                        className={validations && validations.bank_account_number ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_bank_active ? false : true}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        ePay
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_epay_active"
                                                checked={popup.data?.is_epay_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_epay_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        ePay Client ID
                                    </label>

                                    <input
                                        type="text"
                                        name="epay_client_id"
                                        value={popup.data ? popup.data.epay_client_id : ''}
                                        className={validations && validations.epay_client_id ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_epay_active ? false : true}
                                    />

                                </div>
                            </div>


                            <div className="row">
                                <div className="col">
                                    <label>
                                        ePay Client Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="epay_client_secret"
                                        value={popup.data ? popup.data.epay_client_secret : ''}
                                        className={validations && validations.epay_client_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_epay_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        PayPal
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_paypal_active"
                                                checked={popup.data?.is_paypal_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_paypal_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        PayPal Client ID
                                    </label>

                                    <input
                                        type="text"
                                        name="paypal_client_id"
                                        value={popup.data ? popup.data.paypal_client_id : ''}
                                        className={validations && validations.paypal_client_id ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_paypal_active ? false : true}
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        PayPal Client Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="paypal_client_secret"
                                        value={popup.data ? popup.data.paypal_client_secret : ''}
                                        className={validations && validations.paypal_client_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_paypal_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="row">
                    <div className="col">
                        <div className="pannel">
                            <div className="row">
                                <div className="col">
                                    <h3>
                                        Stripe
                                    </h3>
                                </div>
                                <div
                                    className="col"
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BlueSwitch
                                                name="is_stripe_active"
                                                checked={popup.data?.is_stripe_active ? true : false}
                                                onChange={handleSwitchChange}
                                                value={popup.data?.is_stripe_active}
                                            />
                                        }
                                        label={trans('labels.active')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Key
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_key"
                                        value={popup.data ? popup.data.stripe_key : ''}
                                        className={validations && validations.stripe_key ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_secret"
                                        value={popup.data ? popup.data.stripe_secret : ''}
                                        className={validations && validations.stripe_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col">
                                    <label>
                                        Stripe Webhook Secret
                                    </label>

                                    <input
                                        type="text"
                                        name="stripe_webhook_secret"
                                        value={popup.data ? popup.data.stripe_webhook_secret : ''}
                                        className={validations && validations.stripe_webhook_secret ? 'validate' : ''}
                                        onChange={handleInputChange}
                                        disabled={popup.data?.is_stripe_active ? false : true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Payments)